module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/voice-avatar-01-8997b8cd6c028094ab9c755b74a13d7a.png";